import {
    AfterViewInit,
    Component,
    Inject,
    NgZone,
    OnDestroy,
    OnInit,
    Optional,
    ViewChild,
} from '@angular/core';
import { NgForm, Validators } from '@angular/forms';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { delay } from 'rxjs/operators';

import { Password } from '../auth/auth.model';
import { AuthService } from '../auth/auth.service';
import { AbstractCmpsForm, CmpsFormFields } from '../common/common.form';

import { TranslationKeyMap } from './profile.i18n';

const PasswordFormFields: CmpsFormFields = {
    OLD_PASSWORD: {
        id: 'oldPassword',
        name: 'oldPassword',
        label: TranslationKeyMap._691_OLD_PASSWORD,
        placeholder: TranslationKeyMap._691_OLD_PASSWORD,
        validators: [Validators.required],
        validationMsgs: {
            required:
                TranslationKeyMap._640__FIELD_LABEL__IS_A_REQUIRED_FIELD__PLEASE_ENTER_A__FIELD_LABEL_,
        },
    },
    NEW_PASSWORD: {
        id: 'newPassword',
        name: 'newPassword',
        label: TranslationKeyMap._692_NEW_PASSWORD,
        placeholder: TranslationKeyMap._692_NEW_PASSWORD,
        validators: [Validators.required, Validators.minLength(5)],
        validationMsgs: {
            required:
                TranslationKeyMap._640__FIELD_LABEL__IS_A_REQUIRED_FIELD__PLEASE_ENTER_A__FIELD_LABEL_,
            minlength:
                TranslationKeyMap._837_PASSWORD_MUST_BE_A_MINIMUM_OF__REQUIREDLENGTH__CHARACTERS_,
        },
    },
    NEW_PASSWORD_CONFIRM: {
        id: 'newPasswordConfirm',
        name: 'newPasswordConfirm',
        label: TranslationKeyMap._693_CONFIRM_NEW_PASSWORD,
        placeholder: TranslationKeyMap._693_CONFIRM_NEW_PASSWORD,
        // requiredWhenValidator, textEqualValidator
        validationMsgs: {
            requiredWhen: null,
            textEqual:
                TranslationKeyMap._653_PASSWORDS_DO_NOT_MATCH__PLEASE_TRY_AGAIN_,
        },
    },
};

class PasswordForm extends AbstractCmpsForm {
    constructor(protected _translateService: TranslateService) {
        super(PasswordFormFields, _translateService);
    }

    get name(): string {
        return 'passwordForm';
    }
}

@Component({
    selector: 'cmps-profile-password',
    templateUrl: './password.profile.component.html',
})
export class PasswordProfileComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    @ViewChild('passwordNgForm', { static: true })
    passwordNgForm: NgForm;

    i18n = TranslationKeyMap;
    model: Password;
    form: PasswordForm;
    private _ngZoneSub: Subscription;
    private _updateSub: Subscription;
    success: boolean;
    failure: boolean;

    constructor(
        private readonly _ngZone: NgZone,
        private readonly _translateService: TranslateService,
        private readonly _authService: AuthService,
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            PasswordProfileComponent,
            boolean
        >,
        @Optional()
        @Inject(CMPS_DIALOG_DATA) /** @private */
        readonly _data: { forced: boolean },
    ) {
        this.form = new PasswordForm(_translateService);
    }

    ngOnInit(): void {
        this.model = {
            old: null,
            password: null,
        };
    }

    ngAfterViewInit(): void {
        this._ngZoneSub = this._ngZone.onStable.subscribe(() => {
            if (this.passwordNgForm) {
                this.form.form = this.passwordNgForm;
                try {
                    this.form.bind();
                } catch (err) {
                    console.error(err);
                }
            }
            this._ngZoneSub.unsubscribe();
        });
    }

    ngOnDestroy(): void {
        if (this._updateSub) {
            this._updateSub.unsubscribe();
        }
        if (this._ngZoneSub) {
            this._ngZoneSub.unsubscribe();
        }
    }

    onSubmit(): void {
        this.form.validate();
        if (!this.form.isValid()) return;

        this.failure = false;
        this.form.submitted = true;
        this._updateSub = this._authService
            .updatePassword(this.model)
            .pipe(delay(1000))
            // eslint-disable-next-line no-return-assign
            .subscribe(
                () => (this.success = true),
                (error) => {
                    this.failure = true;
                    this.form.serverError =
                        error.message !== 'null' ? error.message : null;
                    this.form.submitted = false;
                },
                // eslint-disable-next-line no-return-assign
                () => (this.form.submitted = false),
            );
    }
}
